/// <amd-module name="Repos/Changes/Components/ChangeSummaryBinaryContent" />
import * as React from "react";
import { useChangesContext } from "Repos/ChangesCommon/ChangesContext";
import { IFileDiff } from "Repos/ChangesCommon/Contracts";
import { IBinaryDiffViewerProps, IBinaryViewerProps, IFileContentDetails } from "Repos/Common/Contracts/Editor";
import { getFileExtension } from "Repos/Common/Util/File";
import { WrappedComponent } from "VSS/Platform/Layout";

export interface IChangeSummaryBinaryContentProps {
    fileDiff: IFileDiff;
}

export function ChangeSummaryBinaryContent<TVersionDescriptor>(props: IChangeSummaryBinaryContentProps): JSX.Element {
    const { fileDiff } = props;
    const { filesService } = useChangesContext<TVersionDescriptor>();

    let modifiedUrl: string | undefined;
    let modifiedContent: IFileContentDetails | undefined;

    if (fileDiff.modifiedFile) {
        modifiedUrl = filesService.getFileDownloadUrl(
            fileDiff.modifiedFile.serverItem,
            filesService.convertVersionToDescriptor(fileDiff.modifiedFile.version)
        );

        modifiedContent = {
            content: "",
            contentTruncated: false,
            objectId: filesService.getObjectId(fileDiff.modifiedFile),
            resourceUri: "",
            metadata: {
                contentType: "",
                encoding: 0,
                extension: getFileExtension(fileDiff.modifiedFile.serverItem),
                fileName: fileDiff.modifiedFile.serverItem,
                isBinary: true,
                isImage: false,
                vsLink: ""
            }
        };
    }

    let originalUrl: string | undefined;
    let originalContent: IFileContentDetails | undefined;
    if (fileDiff.originalFile) {
        originalUrl = filesService.getFileDownloadUrl(
            fileDiff.originalFile.serverItem,
            filesService.convertVersionToDescriptor(fileDiff.originalFile.version)
        );

        originalContent = {
            content: "",
            contentTruncated: false,
            objectId: filesService.getObjectId(fileDiff.originalFile),
            resourceUri: "",
            metadata: {
                contentType: "",
                encoding: 0,
                extension: getFileExtension(fileDiff.originalFile.serverItem),
                fileName: fileDiff.originalFile.serverItem,
                isBinary: true,
                isImage: false,
                vsLink: ""
            }
        };
    }

    return (
        <div className={"flex-row scroll-hidden repos-binary-summary-content"}>
            {originalUrl && modifiedUrl ? (
                <WrappedComponent<IBinaryDiffViewerProps>
                    wrappedType="repos-binary-diff-viewer"
                    dependencies={["ms.vss-code-web.code-editor"]}
                    wrappedProps={{
                        getModifiedDownloadUrl: () => modifiedUrl!,
                        modifiedContent: modifiedContent!,
                        getOriginalDownloadUrl: () => originalUrl!,
                        originalContent: originalContent!,
                        onlyIncludeContent: true
                    }}
                />
            ) : (
                <WrappedComponent<IBinaryViewerProps>
                    wrappedType="repos-binary-viewer"
                    dependencies={["ms.vss-code-web.code-editor"]}
                    wrappedProps={{
                        getDownloadUrl: () => modifiedUrl || originalUrl!,
                        content: modifiedContent || originalContent!,
                        onlyIncludeContent: true
                    }}
                />
            )}
        </div>
    );
}
